import { Theme } from '@mui/material/styles'

export default function Backdrop(_: Theme) {
  return {
    MuiBackdrop: {},
  }
}
